import { ReplaySubject } from 'rxjs';

import {
  SelectionEvent,
  SelectionEventInitiator,
  useGridSelectedRows
} from '@/pages/ContractLines/hooks/useGridSelectionSubscription';
import { VarBillingUsageDetailOutput } from '@/graphql/contracts/_generated_/contracts';

export type UsageLineSelectionPayload = {
  usageDetailsLine: VarBillingUsageDetailOutput;
};

export const variableLinesSelectionObservable =
  new ReplaySubject<SelectionEvent<UsageLineSelectionPayload>>();

export function clearLinesSelection() {
  variableLinesSelectionObservable.next({
    initiator: SelectionEventInitiator.EXTERNAL_INITIATOR,
    selectedGridRows: []
  });
}

export function useSelectedLines() {
  return useGridSelectedRows(variableLinesSelectionObservable);
}